import { render, staticRenderFns } from "./editTelegram.vue?vue&type=template&id=0ce03d49&scoped=true"
import script from "./editTelegram.vue?vue&type=script&lang=js"
export * from "./editTelegram.vue?vue&type=script&lang=js"
import style0 from "./editTelegram.vue?vue&type=style&index=0&id=0ce03d49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce03d49",
  null
  
)

export default component.exports